import { IntegrityMonitorEventsWebComponent } from './component/IntegrityMonitorEventsWebComponent';
import { WEB_COMPONENT_INTEGRITY_MONITOR_EVENTS } from '../../../webcomponents.constants';

export { IntegrityMonitorEventsWebComponent };

window.customElements.define(WEB_COMPONENT_INTEGRITY_MONITOR_EVENTS, IntegrityMonitorEventsWebComponent);
